import { useEffect } from 'react';
import { ensureCssHealthProbe } from '../shared/utils/config/cssHealth';
import {
  recordSignedUrlSessionStart,
  recoverFromBackgroundOnMount,
  subscribeToVisibilityForSignedUrlRefresh,
} from '../shared/utils/config/signedUrlRefresh';

/**
 * App-level handler for resume recovery after background / long suspend.
 *
 * - Installs a CSS health probe and checks styles on every visibility resume.
 *   iOS Safari can purge stylesheets while React state survives; triggers reload.
 * - Records signed-URL session start on mount.
 * - Persists hidden timestamp in localStorage (survives iOS sessionStorage clears).
 * - After 55+ minutes hidden: emits an in-place signed-URL refresh event (chat media
 *   re-signs keys without depending on reload), then reloads so feed/profile state
 *   that still bakes signed URLs into memory is renewed.
 *
 * Mount once at the app root (e.g. inside App in index.js).
 */
function SignedUrlRefreshHandler() {
  useEffect(() => {
    ensureCssHealthProbe();
    // Recovery first — may reload; only record session start when staying on page.
    recoverFromBackgroundOnMount();
    recordSignedUrlSessionStart();

    const unsubscribe = subscribeToVisibilityForSignedUrlRefresh();
    return unsubscribe;
  }, []);

  return null;
}

export default SignedUrlRefreshHandler;
